export default __webpack_public_path__ + "static/media/main-control-center-panel.ca9c8aca.jpg";